// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"41eb3f94","239":"b4f83ae6","453":"7834bb51","667":"b879a5e4"}[chunkId] + ".chunk.js";
};